import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col px-4 gap-4 mt-4 w-full items-center" }
const _hoisted_3 = { class: "w-full flex justify-start border border-gray-300 rounded-md p-4" }
const _hoisted_4 = { class: "flex w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" }
const _hoisted_5 = { class: "flex col-span-1 md:col-span-2 lg:col-span-3 justify-end" }
const _hoisted_6 = { class: "w-full flex justify-start border border-gray-300 rounded-md p-4" }
const _hoisted_7 = { class: "w-full flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-full h-12 p-4 shadow-md" }, [
      _createElementVNode("span", { class: "text-large text-black text-bold font-600 mr-3" }, "Layout4")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form_item, { label: "Activity name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity zone" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.region,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.region) = $event)),
                    placeholder: "please select your zone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Zone one",
                        value: "shanghai"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Zone two",
                        value: "beijing"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity time" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 11 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date1,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date1) = $event)),
                        type: "date",
                        placeholder: "Pick a date",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 2,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createElementVNode("span", { class: "text-gray-500" }, "-", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 11 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_time_picker, {
                        modelValue: _ctx.form.date2,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.date2) = $event)),
                        placeholder: "Pick a time",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  class: "w-24",
                  type: "primary",
                  onClick: _ctx.handleSubmit
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("新規登録")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "w-24",
                  type: "primary",
                  onClick: _ctx.handleSubmit
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("検索")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          "table-layout": _ctx.tableLayout,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: "Date"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name"
            }),
            _createVNode(_component_el_table_column, {
              class: "hidden",
              prop: "address",
              label: "Address"
            })
          ]),
          _: 1
        }, 8, ["data", "table-layout", "loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.tableLayout,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tableLayout) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { value: "fixed" }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("fixed")
              ])),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { value: "auto" }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("auto")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_pagination, {
          class: "ml-4",
          "current-page": _ctx.currentPage,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: 400,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "page-size", "onSizeChange", "onCurrentChange"])
      ])
    ])
  ]))
}